import axios from 'axios'
export default {
  index({ href, created_at, page }) {
    return axios.get(`/api/tests?href=${href}&created_at=${created_at}&page=${page}`)
      .then(response => response.data)
  }
}


